export * from './hooks'

export const resolvers = {
  Mutation: {
    setUpgradeType: (_, { upgradeType }, { cache }) => {
      const data = { upgradeType, __typename: 'UpgradeType' };
      cache.writeData({ data });
    }
  }
}